import { writable } from "svelte/store";
import type { Writable } from "svelte/store";

export const loadedFiles: Writable<(string | ArrayBuffer)[]> = writable([])
